import { useTranslation } from "react-i18next";
import type { Person } from "@/services/api";

export const getBirthdayText = (person: Person | null | undefined): string => {
  if (!person) {
    return "";
  }

  const { t } = useTranslation();

  const firstName = person.firstName ?? t("common.unknown");
  const lastName = person.lastName ?? t("common.person");

  return t("calendarPage.birthdayText", {
    firstName,
    lastName,
  });
};
